"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebformFieldRouter = void 0;
const react_1 = __importDefault(require("react"));
const TextField_1 = require("./fields/TextField");
const SelectField_1 = require("./fields/SelectField");
const DateField_1 = require("./fields/DateField");
const PhoneField_1 = require("./fields/PhoneField");
const EmailField_1 = require("./fields/EmailField");
const TextAreaField_1 = require("./fields/TextAreaField");
const FileField_1 = require("./fields/FileField");
const ImageField_1 = require("./fields/ImageField");
const RadioField_1 = require("./fields/RadioField");
const CheckboxField_1 = require("./fields/CheckboxField");
const fieldComponents = {
    text: TextField_1.TextField,
    number: TextField_1.TextField,
    email: EmailField_1.EmailField,
    phone: PhoneField_1.PhoneField,
    date: DateField_1.DateField,
    select: SelectField_1.SelectField,
    radio: RadioField_1.RadioField,
    checkbox: CheckboxField_1.CheckboxField,
    textarea: TextAreaField_1.TextAreaField,
    file: FileField_1.FileField,
    image: ImageField_1.ImageField,
};
const WebformFieldRouter = (props) => {
    const Component = fieldComponents[props.field.type] || TextField_1.TextField;
    return react_1.default.createElement(Component, { ...props });
};
exports.WebformFieldRouter = WebformFieldRouter;
